import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { 
  ArrowLeft,
  Building2,
  Mail,
  CreditCard,
  User,
  Shield,
  Bell,
  ChevronRight
} from "lucide-react";
import { useAuth } from "../context/AuthContext";
import AnimatedLogo from "../components/AnimatedLogo";
import ThemeToggle from "../components/ThemeToggle";
import UserMenu from "../components/UserMenu";

export default function SettingsPage() {
  const { user } = useAuth();

  const settingsLinks = [
    {
      title: "Mon compte",
      description: "Gérez votre email et mot de passe",
      icon: User,
      to: "/settings/account",
      color: "text-orange-500 bg-orange-100 dark:bg-orange-900/30"
    },
    {
      title: "Mon entreprise",
      description: "Gérez les informations de votre organisation",
      icon: Building2,
      to: "/settings/company",
      color: "text-blue-500 bg-blue-100 dark:bg-blue-900/30"
    },
    {
      title: "Paramètres Email",
      description: "Configurez SMTP et templates d'emails",
      icon: Mail,
      to: "/settings/email",
      color: "text-purple-500 bg-purple-100 dark:bg-purple-900/30"
    },
    {
      title: "Facturation",
      description: "Gérez votre abonnement et factures",
      icon: CreditCard,
      to: "/billing",
      color: "text-green-500 bg-green-100 dark:bg-green-900/30"
    }
  ];

  return (
    <div className="min-h-screen bg-muted/30">
      {/* Header */}
      <header className="bg-card border-b border-border sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 py-2 sm:py-4 flex items-center justify-between gap-2">
          <div className="flex items-center gap-4">
            <Link to="/dashboard">
              <Button variant="ghost" size="icon">
                <ArrowLeft className="w-5 h-5" />
              </Button>
            </Link>
            <AnimatedLogo linkTo="/dashboard" showAnimation={true} size="small" />
          </div>
          <div className="flex items-center gap-1 sm:gap-3">
            <ThemeToggle />
            <UserMenu />
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <div className="mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-foreground" style={{ fontFamily: 'Outfit' }}>
            Paramètres
          </h1>
          <p className="text-muted-foreground mt-1">
            Gérez votre compte et vos préférences
          </p>
        </div>

        <div className="space-y-4">
          {settingsLinks.map((link) => (
            <Link key={link.to} to={link.to}>
              <Card className="bg-card hover:border-primary/30 transition-colors cursor-pointer group">
                <CardContent className="p-4 flex items-center gap-4">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${link.color}`}>
                    <link.icon className="w-6 h-6" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-foreground">{link.title}</h3>
                    <p className="text-sm text-muted-foreground">{link.description}</p>
                  </div>
                  <ChevronRight className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors" />
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}
